const STORAGE_KEY = 'cookieConsent'

// EU-27 + EEA (IS, LI, NO) + UK + US-CA (ISO 3166-2 codes)
export const REGULATED_REGIONS = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
  'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'GB', 'US-CA',
]

/** Maps site cookie prefs to Google Consent Mode v2 params */
export const prefsToConsentParams = (prefs) => ({
  analytics_storage: prefs.analytics ? 'granted' : 'denied',
  ad_storage: prefs.advertising ? 'granted' : 'denied',
  ad_user_data: prefs.advertising ? 'granted' : 'denied',
  ad_personalization: prefs.advertising ? 'granted' : 'denied',
})

/** Synchronous read of confirmed consent from localStorage/cookie */
export const readStoredConsent = () => {
  if (typeof window === 'undefined') return null
  try {
    let stored = null
    try {
      stored = window.localStorage.getItem(STORAGE_KEY)
    } catch {
      // localStorage unavailable, try cookie
      const m = document.cookie.match(new RegExp(`${STORAGE_KEY}=([^;]+)`))
      if (m) stored = decodeURIComponent(m[1])
    }
    if (stored) {
      const prefs = JSON.parse(stored)
      if (prefs.confirmed) return prefs
    }
  } catch {
    // parse error — treat as no stored consent
  }
  return null
}

/** Check if country/state is in a regulated region (EU/EEA/UK/CA) */
export const isRegulatedRegion = (countryCode, state) => {
  if (!countryCode) return false
  const cc = countryCode.toUpperCase()
  if (cc === 'US') {
    return state && state.toUpperCase() === 'CA'
  }
  return REGULATED_REGIONS.includes(cc)
}

const GEO_CACHE_KEY = 'geoData'

/** Read cached geo data from sessionStorage */
export const getCachedGeo = () => {
  try {
    const raw = window.sessionStorage.getItem(GEO_CACHE_KEY)
    if (raw) return JSON.parse(raw)
  } catch {
    // ignore
  }
  return null
}

/** Cache geo data to sessionStorage */
export const setCachedGeo = (data) => {
  try {
    window.sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify(data))
  } catch {
    // ignore
  }
}
